import { fileUrl, formatPrice } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Plus, Check } from "lucide-react";

export const ProductCard = ({ product, inCartQty, onAdd, index }) => {
  const available = product.in_stock !== false;
  return (
    <div
      data-testid={`product-card-${product.id}`}
      className="group card-rise bg-card rounded-2xl border border-border overflow-hidden flex flex-col float-up"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative aspect-square overflow-hidden bg-muted">
        {product.image_url ? (
          <img
            src={fileUrl(product.image_url)}
            alt={product.name}
            className="w-full h-full object-cover img-zoom"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-muted-foreground text-sm">
            Pas d'image
          </div>
        )}
        {product.category && (
          <Badge className="absolute top-3 left-3 bg-white/90 text-[#0A1026] backdrop-blur-sm border-0 hover:bg-white/90">
            {product.category}
          </Badge>
        )}
        {!available && (
          <div className="absolute inset-0 bg-black/45 flex items-center justify-center">
            <span className="text-white font-semibold text-sm tracking-wide uppercase">
              Rupture de stock
            </span>
          </div>
        )}
      </div>

      <div className="p-4 flex flex-col flex-1">
        <h3 className="font-heading text-lg font-bold leading-snug">{product.name}</h3>
        {product.description && (
          <p className="text-sm text-muted-foreground mt-1 line-clamp-2 flex-1">
            {product.description}
          </p>
        )}
        <div className="flex items-center justify-between mt-4">
          <span className="text-xl font-extrabold text-terracotta">
            {formatPrice(product.price)}
          </span>
          <button
            data-testid={`add-to-cart-${product.id}`}
            disabled={!available}
            onClick={() => onAdd(product)}
            className="brand-terracotta text-white rounded-full h-11 w-11 flex items-center justify-center disabled:opacity-40 disabled:cursor-not-allowed active:scale-90 transition-transform relative"
          >
            {inCartQty > 0 ? (
              <>
                <Check className="h-5 w-5" />
                <span className="absolute -top-1 -right-1 bg-[#0A1026] text-white text-[11px] font-bold rounded-full h-5 min-w-5 px-1 flex items-center justify-center">
                  {inCartQty}
                </span>
              </>
            ) : (
              <Plus className="h-5 w-5" />
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
